const profileColumns = [
  {
    label: 'Name',
    value: 'name',
    textId: 'fleetadmin.profile.table.name',
    disabled: true,
  },
  {
    label: 'Model',
    value: 'model',
    textId: 'fleetadmin.profile.table.vehiclemodel',
    disabled: false,
  },
  {
    label: 'Brand',
    value: 'brandId',
    textId: 'fleetadmin.profile.table.brand',
    disabled: false,
  },
  {
    label: 'Brand Name',
    value: 'brandName',
    textId: 'fleetadmin.profile.table.vehiclebrand',
    disabled: false,
  },
];

export const defaultSelectedProfileColumns = profileColumns.map(
  (profileColumn) => profileColumn.value
);

export default profileColumns;
